import {h, Component, Fragment} from "preact";

import formatOdd from "../../../services/odds-format";


export function CardHeaderRow({children}) {
	return <div class="cl-pt-card-head-row flex h-8 items-center border-t border-t-harif-900 border-b border-b-harif-950 bg-harif-800 text-white">{children}</div>
}

export function ThreeDots() {
	return <div class="cl-pt-3-dots flex h-full px-2">
	  <div class="flex h-full w-2 flex-none items-center justify-center"><div class="h-1 w-1 rounded-full bg-white"></div></div>
	  <div class="flex h-full w-2 flex-none items-center justify-center"><div class="h-1 w-1 rounded-full bg-white"></div></div>
	  <div class="flex h-full w-2 flex-none items-center justify-center"><div class="h-1 w-1 rounded-full bg-white"></div></div>
	</div>
}

export function OneDotAlt() {
	return <div class="cl-pt-1-dot-alt flex h-full px-2">
	  <div class="flex h-full w-2 flex-none items-center justify-center"><div class="h-1 w-1 rounded-full bg-amber-500"></div></div>
	</div>
}

export function CardHeaderTitle({children}) {
	return <div class="cl-pt-card-head-ttl min-w-0 grow truncate text-sm">{children}</div>
}

export function CardHeaderSports({children}) {
	return <div class="cl-pt-card-head-sports flex h-full text-sm">{children}</div>
}
export function SportNameButton({children, active, onClick}) {
	if (active)
		return <div class="cl-pt-sprt-name-btn flex items-center border-l border-l-harifzinc-950 px-3 bg-harifzinc-900 text-white" onClick={onClick}>{children}</div>
	return <div class="cl-pt-sprt-name-btn flex items-center border-l border-l-harifzinc-950 px-3" onClick={onClick}>{children}</div>
}

export function SubTabsOddsContainer({children}) {
	return <div class="cl-pt-subtab-cont fn-tabs-markets gap-2 p-3 grid grid-cols-6 border-b border-b-harif-850 bg-harif-750 text-sm">
		{children}
	</div>
}

export function OddsTableHeadRow({children}) {
	return <div class="cl-pt-odd-tab-h-row flex h-6 items-center border-t border-b border-t-harif-800 border-b-harif-950 bg-harif-900 text-xs leading-tight text-white">{children}</div>
}
export function HeadRowCellId({children, onClick}) {
	return <div class="cl-pt-h-row-cell-id flex h-full w-9 items-center justify-center text-center" onClick={onClick}>{children}</div>
}
export function HeadRowCellTime({children, onClick}) {
	return <div class="cl-pt-h-row-cell-time flex h-full w-11 items-center justify-center text-center" onClick={onClick}>{children}</div>
}
export function HeadRowCellEvent({children, onClick}) {
	return <div class="cl-pt-h-row-cell-evt flex h-full min-w-0 grow items-center justify-center text-center" onClick={onClick}>{children}</div>
}
export function ContentRowCellEvent({children, onClick}) {
	return <div class="cl-pt-cont-row-cell-evt flex h-full min-w-0 grow items-center" onClick={onClick}>{children}</div>
}

export function HeadOddCell({children}) {
	return <div class="cl-pt-h-odd-cell flex h-full w-1/2 items-center justify-center text-center truncate">
		<span class="truncate">{children}</span>
	</div>
}
export function HeadMoreCell({children}) {
	return <div class="cl-pt-h-more-cell flex h-full w-9 flex-none items-center justify-center text-center">{children}</div>
}


export function OddsWidthContainer({children}) {
	return <div class="cl-pt-ow-cont flex h-full w-2/5 flex-none">{children}</div>
}
export function OddsWidthContainerLarge({children}) {
	return <div class="cl-pt-ow-cont-lg flex h-full w-3/5 flex-none">{children}</div>
}
export function OddsWidthEmpty({children}) {
	return <div class="cl-pt-ow-empt flex h-full grow">{children}</div>
}


export function EventRow({children}) {
	return <div class="cl-pt-evt-row flex h-7 border-b border-t border-b-harif-950 border-t-harif-800 bg-harif-900 text-xs">{children}</div>
}

export function EventOddButton({value, active, onClick, selected}) {
	if (selected)
		return <div class="cl-pt-evt-odd-btn cursor-pointer flex h-full w-1/2 items-center justify-center border-l border-r border-l-harif-950 border-r-harif-800 text-center font-extrabold text-black bg-amber-500" onClick={onClick}>
			{!!value ? formatOdd(value) : '-'}
		</div>
	return <div class="cl-pt-evt-odd-btn cursor-pointer flex h-full w-1/2 items-center justify-center border-l border-r border-l-harif-950 border-r-harif-800 text-center font-bold text-amber-500" onClick={onClick}>
		{!!value ? formatOdd(value) : '-'}
	</div>
}
export function MoreButton({children, onClick}) {
	return <div class="cl-pt-more-btn cursor-pointer flex h-full w-9 flex-none items-center justify-center border-l border-l-harifzinc-800 pb-1 text-center text-base font-bold leading-tight" onClick={onClick}>{children}</div>
}

export function ShowMoreFooter({children, onClick}) {
	return <div class="cl-pt-show-more-footer cursor-pointer flex h-8 items-center justify-around text-sm text-custom-orange" onClick={onClick}>{children}</div>
}


export function LastMinuteEventsExample() {
	return <div>
	  <CardHeaderRow>
		<ThreeDots />
		<CardHeaderTitle>Last Minute</CardHeaderTitle>
		<CardHeaderSports>
		  <SportNameButton>Soccer</SportNameButton>
		  <SportNameButton>Soccer</SportNameButton>
		</CardHeaderSports>
	  </CardHeaderRow>
	  <OddsTableHeadRow>
		<HeadRowCellId>ID</HeadRowCellId>
		<HeadRowCellTime>Time</HeadRowCellTime>
		<HeadRowCellEvent>Event</HeadRowCellEvent>
		<OddsWidthContainer>
		  <HeadOddCell>1</HeadOddCell>
		  <HeadOddCell>X</HeadOddCell>
		  <HeadOddCell>2</HeadOddCell>
		  <HeadMoreCell />
		</OddsWidthContainer>
	  </OddsTableHeadRow>
	  <div>
		<EventRow>
		<HeadRowCellId>ID</HeadRowCellId>
		<HeadRowCellTime>Time</HeadRowCellTime>
		<HeadRowCellEvent>Event</HeadRowCellEvent>
		<OddsWidthContainer>
		  <EventOddButton>2.50</EventOddButton>
		  <EventOddButton>1.82</EventOddButton>
		  <EventOddButton>3.20</EventOddButton>
		  <MoreButton>+</MoreButton>
	    </OddsWidthContainer>
		</EventRow>
	  </div>
	  <div>
		<EventRow>
		<HeadRowCellId>ID</HeadRowCellId>
		<HeadRowCellTime>Time</HeadRowCellTime>
		<HeadRowCellEvent>Event</HeadRowCellEvent>
		<OddsWidthContainer>
		  <EventOddButton>2.50</EventOddButton>
		  <EventOddButton>1.82</EventOddButton>
		  <EventOddButton>3.20</EventOddButton>
		  <MoreButton>+</MoreButton>
	    </OddsWidthContainer>
		</EventRow>
	  </div>
	  <div>
		<EventRow>
		<HeadRowCellId>ID</HeadRowCellId>
		<HeadRowCellTime>Time</HeadRowCellTime>
		<HeadRowCellEvent>Event</HeadRowCellEvent>
		<OddsWidthContainer>
		  <EventOddButton>2.50</EventOddButton>
		  <EventOddButton>1.82</EventOddButton>
		  <EventOddButton>3.20</EventOddButton>
		  <MoreButton>+</MoreButton>
	    </OddsWidthContainer>
		</EventRow>
	  </div>
	  <ShowMoreFooter>Show More {">>"}</ShowMoreFooter>
	</div>
}


export function TournamentSelectorHead({children}) {
	return <div class="cl-pt-tourn-sel-head flex h-8 items-center justify-between border-b border-b-harifzinc-950 bg-harifzinc-800 text-amber-500">{children}</div>
}
export function TournamentHeadCell({children}) {
	return <div class="cl-pt-tourn-head-cell flex h-full w-full grow items-center">{children}</div>
}
export function TournamentHeadButtonCell({children}) {
	return <div class="cl-pt-tourn-head-btn-cell h-full w-9 flex-none border-l border-l-harifzinc-950">{children}</div>
}

export function CategoryNameRow({children}) {
	return <div class="cl-pt-cat-name-row flex h-8 items-center justify-between border-b border-b-harifzinc-950 bg-harifzinc-800 text-white">{children}</div>
}

export function CategoryContentsRow({children}) {
	return <div class="cl-pt-cat-cont-row grid grid-cols-3 gap-1 border-b border-t border-b-harifzinc-950 border-t-harifzinc-800 bg-harifzinc-900 px-2 py-2 text-sm text-white">{children}</div>
}

export function TournamentCell({children}) {
	return <div class="cl-pt-tourn-cell flex h-8 items-center justify-start px-3">{children}</div>
}
export function TournamentCheckbox({children, active, onInput}) {
	return <div class="cl-pt-tourn-check h-6 w-6 flex-none">{children}</div>
}
export function TournamentNameLabel({children, active, onInput}) {
	return <div class="cl-pt-tourn-name-lbl h-6 w-6 flex-none">{children}</div>
}

export function SportTournamentSelector() {
	return <div>
	  <TournamentSelectorHead>
		<TournamentHeadCell>
		  <OneDotAlt />
		  <CardHeaderTitle>Football</CardHeaderTitle>
		</TournamentHeadCell>
		<TournamentHeadButtonCell />
		<TournamentHeadButtonCell />
		<TournamentHeadButtonCell />
	  </TournamentSelectorHead>
	  <div>
		<CategoryNameRow>
		  <TournamentHeadCell>
			<ThreeDots />
			<CardHeaderTitle>Italy</CardHeaderTitle>
		  </TournamentHeadCell>
		  <TournamentHeadButtonCell />
		</CategoryNameRow>
		<CategoryContentsRow>
		  <TournamentCell>
			<TournamentCheckbox />
			<TournamentNameLabel>Hello</TournamentNameLabel>
		  </TournamentCell>
		  <TournamentCell>
			<TournamentCheckbox />
			<TournamentNameLabel>Hello</TournamentNameLabel>
		  </TournamentCell>
		  <TournamentCell>
			<TournamentCheckbox />
			<TournamentNameLabel>Hello</TournamentNameLabel>
		  </TournamentCell>
		  <TournamentCell>
			<TournamentCheckbox />
			<TournamentNameLabel>Hello</TournamentNameLabel>
		  </TournamentCell>
		  <TournamentCell>
			<TournamentCheckbox />
			<TournamentNameLabel>Hello</TournamentNameLabel>
		  </TournamentCell>
		</CategoryContentsRow>
	  </div>
	</div>
}


export function TournamentSportName({children}) {
	return <div class="cl-pt-tourn-sport-name min-w-0 truncate text-sm">{children}</div>
}
export function TournamentFullName({children}) {
	return <div class="cl-pt-tourn-full-name min-w-0 grow truncate text-center text-sm">{children}</div>
}
export function TournamentCardButtonCell({children}) {
	return <div class="cl-pt-trn-card-btn-cel min-w-0 grow truncate text-center text-sm flex items.center justify-center">{children}</div>
}

export function TournamentBigTabsContainer({children}) {
	return <div class="cl-pt-tnr-bigtab-cont relative">{children}</div>
}
export function TabsCollapseButton({children, onClick}) {
	return <div 
			   class="cl-pt-tab-coll-btn bg-harifzinc-900800 absolute bottom-0 right-0 flex h-8 w-9 items-center justify-center border border-b-harifzinc-950 border-l-harifzinc-950 border-r-harifzinc-800 border-t-harifzinc-800 bg-harifzinc-900 text-white"
			   onClick={onClick}>
		{children}
	</div>
}
export function TabsWrapper({children}) {
	return <div class="cl-pt-tab-wrap fn-tabs grid grid-cols-5 border-b border-b-harifzinc-950 bg-harifzinc-900 text-sm">{children}</div>
}
export function TabButton({children, active, onClick}) {
	if (active)
		return <div class="cl-pt-tab-button flex h-8 items-center justify-center border border-b-harifzinc-950 border-l-harifzinc-950 border-r-harifzinc-800 border-t-harifzinc-800 bg-amber-500 text-black" onClick={onClick}>
			<span class="truncate">{children}</span>
		</div>
	return <div class="cl-pt-tab-button flex h-8 items-center justify-center border border-b-harifzinc-950 border-l-harifzinc-950 border-r-harifzinc-800 border-t-harifzinc-800 bg-harifzinc-900 text-white" onClick={onClick}>
		<span class="truncate">{children}</span>
	</div>
}

export function SubTabsContainer({children}) {
	return <div class="cl-pt-subtab-cont fn-tabs-markets grid grid-cols-6 border-b border-b-harifzinc-700 bg-harifzinc-800 text-sm">
		{children}
	</div>
}

export function SubTabButton({children, active, onClick}) {
	if (active)
		return <div class="cl-pt-subtab-btn flex h-8 items-center justify-center border border-b-harifzinc-900 border-l-harifzinc-900 border-r-harifzinc-700 border-t-harifzinc-700 bg-harifzinc-700 text-white" onClick={onClick}>
			<span class="truncate">{children}</span>
		</div>
	return <div class="cl-pt-subtab-btn flex h-8 items-center justify-center border border-b-harifzinc-900 border-l-harifzinc-900 border-r-harifzinc-700 border-t-harifzinc-700 bg-harifzinc-800 text-white" onClick={onClick}>
		<span class="truncate">{children}</span>
	</div>
}


export function TableRowDate({children}) {
	return <div class="cl-pt-tr-date flex h-6 items-center border-b border-b-harifzinc-950 bg-harifzinc-950 text-xs leading-tight text-white">{children}</div>
}
export function DateCell({children}) {
	return <div class="cl-pt-date-cell flex h-full grow items-center justify-start px-1 text-center">{children}</div>
}



export function SingleTournamentCard() {
	return <div>
	  <CardHeaderRow>
		<ThreeDots />
		<TournamentSportName>Football</TournamentSportName>
		<TournamentFullName>Region - Tournament</TournamentFullName>
		<CardHeaderSports>
		  <TournamentCardButtonCell />
		  <TournamentCardButtonCell />
		</CardHeaderSports>
	  </CardHeaderRow>
	  <TournamentBigTabsContainer>
		<TabsWrapper>
		  <TabButton>Tab</TabButton>
		  <TabButton>Tab</TabButton>
		  <TabButton>Tab</TabButton>
		  <TabButton>Tab</TabButton>
		</TabsWrapper>
		<TabsCollapseButton>C</TabsCollapseButton>
	  </TournamentBigTabsContainer>
	  <SubTabsContainer>
		<SubTabButton>Tab</SubTabButton>
		<SubTabButton>Tab</SubTabButton>
		<SubTabButton>Tab</SubTabButton>
		<SubTabButton>Tab</SubTabButton>
		<SubTabButton>Tab</SubTabButton>
		<SubTabButton>Tab</SubTabButton>
		<SubTabButton>Tab</SubTabButton>
	  </SubTabsContainer>
	  <OddsTableHeadRow>
		<HeadRowCellId>ID</HeadRowCellId>
		<HeadRowCellTime>Time</HeadRowCellTime>
		<HeadRowCellEvent>Event</HeadRowCellEvent>
		<OddsWidthContainer>
		  <HeadOddCell>1</HeadOddCell>
		  <HeadOddCell>X</HeadOddCell>
		  <HeadOddCell>2</HeadOddCell>
		  <HeadMoreCell />
		</OddsWidthContainer>
	  </OddsTableHeadRow>
	  <TableRowDate>
		<DateCell>2023-04-18</DateCell>
	  </TableRowDate>
	  <div>
		<EventRow>
			<HeadRowCellId>Live</HeadRowCellId>
			<HeadRowCellTime>Time</HeadRowCellTime>
			<HeadRowCellEvent>Event</HeadRowCellEvent>
			<OddsWidthContainer>
			  <EventOddButton>2.50</EventOddButton>
			  <EventOddButton>1.82</EventOddButton>
			  <EventOddButton>3.20</EventOddButton>
			  <MoreButton>+</MoreButton>
		    </OddsWidthContainer>
		</EventRow>
	  </div>
	  <TableRowDate>
		<DateCell>2023-04-18</DateCell>
	  </TableRowDate>
	  <div>
		<EventRow>
			<HeadRowCellId>Live</HeadRowCellId>
			<HeadRowCellTime>Time</HeadRowCellTime>
			<HeadRowCellEvent>Event</HeadRowCellEvent>
			<OddsWidthContainer>
			  <EventOddButton>2.50</EventOddButton>
			  <EventOddButton>1.82</EventOddButton>
			  <EventOddButton>3.20</EventOddButton>
			  <MoreButton>+</MoreButton>
		    </OddsWidthContainer>
		</EventRow>
	  </div>
	  <div>
		<EventRow>
			<HeadRowCellId>Live</HeadRowCellId>
			<HeadRowCellTime>Time</HeadRowCellTime>
			<HeadRowCellEvent>Event</HeadRowCellEvent>
			<OddsWidthContainer>
			  <EventOddButton>2.50</EventOddButton>
			  <EventOddButton>1.82</EventOddButton>
			  <EventOddButton>3.20</EventOddButton>
			  <MoreButton>+</MoreButton>
		    </OddsWidthContainer>
		</EventRow>
	  </div>
	  <M.BlankSeparator />
	</div>
}
